module.exports = __webpack_public_path__ + "img/7.44f5c1a4.jpg";